import { Link } from "react-router-dom";
import { AuthLayout } from "../components/AuthLayout";
import { Stethoscope, UserRound, Building2, ArrowRight } from "lucide-react";

const OPTIONS = [
  { to: "/signup/gp", icon: Stethoscope, title: "I'm a GP", sub: "Find available clinicians and Simply Refer — free.", testId: "choice-gp" },
  { to: "/clinician/signup", icon: UserRound, title: "I'm an Individual Practitioner", sub: "Solo clinician managing your own calendar and availability.", testId: "choice-clinician" },
  { to: "/clinic/signup", icon: Building2, title: "I'm a Clinic Manager", sub: "Manage multiple clinicians, calendars and billing.", testId: "choice-clinic" },
];

export default function SignupChoice() {
  return (
    <AuthLayout title="Create your account" subtitle="First, tell us who you are." testId="signup-choice-page">
      <div className="space-y-3" data-testid="signup-choice-options">
        {OPTIONS.map(({ to, icon: Icon, title, sub, testId }) => (
          <Link
            key={to}
            to={to}
            data-testid={testId}
            className="group flex items-center gap-4 rounded-lg border border-border bg-white p-4 transition-all hover:border-primary hover:shadow-sm"
          >
            <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-secondary text-secondary-foreground">
              <Icon className="h-5 w-5" />
            </div>
            <div className="min-w-0 flex-1">
              <p className="font-heading text-sm font-semibold text-slate-900">{title}</p>
              <p className="text-sm text-slate-500">{sub}</p>
            </div>
            <ArrowRight className="h-4 w-4 shrink-0 text-slate-400 transition-transform group-hover:translate-x-0.5 group-hover:text-primary" />
          </Link>
        ))}
      </div>
      <p className="mt-6 text-center text-sm text-slate-500">
        Already have an account?{" "}
        <Link to="/login" className="font-medium text-primary hover:underline" data-testid="choice-signin-link">
          Sign in
        </Link>
      </p>
    </AuthLayout>
  );
}
